import { Base } from './_base.model';

export class VendorType extends Base {
  id: string;
  label: string;
  is_new: boolean;
  is_deleted: boolean;

  constructor() {
    super();

    this.is_new = true;
    this.is_deleted = false;
  }
}
